import { Route, Routes } from 'react-router-dom';
import { AuthLayout } from '@/modules/auth/components/auth.layout.tsx';
import { AuthEmailPage } from './pages/auth-email.page';
import { AuthSignUpPage } from './pages/auth-sign-up.page';
import { AuthLoginPage } from './pages/auth-login.page';
import { AuthCodePage } from './pages/auth-code.page';
import { AuthLogoutPage } from './pages/auth-logout.page';
import { AuthForgotPasswordPage } from './pages/auth-forgot-password.page';
import { AuthResetPasswordPage } from './pages/auth-reset-password.page';
import { AuthMagicLinkPage } from './pages/auth-magic-link.page';

const AuthRouter = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route index element={<AuthEmailPage />} />
      <Route path="code" element={<AuthCodePage />} />
      <Route path="sign-up" element={<AuthSignUpPage />} />
      <Route path="login" element={<AuthLoginPage />} />
      <Route path="forgot-password" element={<AuthForgotPasswordPage />} />
      <Route path="reset-password" element={<AuthResetPasswordPage />} />
      <Route path="magic-link" element={<AuthMagicLinkPage />} />
      <Route path="logout" element={<AuthLogoutPage />} />
    </Route>
  </Routes>
);

export default AuthRouter;
